import { getToken } from '@optimus-web/core';
import { SystemWideBannerImportance, SystemWideBannerVariant } from './types';

interface SystemWideBannerProps {
    importance: SystemWideBannerImportance;
    variant: SystemWideBannerVariant;
}

export const getSystemWideBannerBackgroundColor = ({ importance, variant }: SystemWideBannerProps) => {
    if (importance === 'critical') {
        switch (variant) {
            case 'danger':
                return getToken('backgroundAlertDangerPrimary');
            case 'info':
                return getToken('backgroundAlertInfoPrimary');
            case 'warning':
                return getToken('backgroundAlertWarningPrimary');
        }
    }

    if (importance === 'urgent') {
        switch (variant) {
            case 'danger':
                return getToken('backgroundAlertDangerSecondary');
            case 'info':
                return getToken('backgroundAlertInfoSecondary');
            case 'warning':
                return getToken('backgroundAlertWarningSecondary');
        }
    }
};

export const getSystemWideBannerIconColor = ({ importance, variant }: SystemWideBannerProps) => {
    if (importance === 'critical') {
        switch (variant) {
            case 'danger':
                return getToken('textStaticInverse');
            case 'info':
                return getToken('textStaticInverse');
            case 'warning':
                return getToken('textStaticPrimary');
        }
    }

    if (importance === 'urgent') {
        switch (variant) {
            case 'danger':
                return getToken('textAlertDanger');
            case 'info':
                return getToken('textAlertInfo');
            case 'warning':
                return getToken('textAlertWarning');
        }
    }
};

export const getSystemWideBannerTextColor = ({ importance, variant }: SystemWideBannerProps) => {
    if (importance === 'critical' && (variant === 'info' || variant === 'danger')) {
        return getToken('textStaticInverse');
    }

    return getToken('textStaticPrimary');
};
